/* Header: compact-on-scroll, click mega menus, overlay portals. */
(() => {
  const init = () => {
    const header = document.querySelector('[data-header]');
    if (!header || header.dataset.ready) return;
    header.dataset.ready = 1;

    // Drawers/modals live inside the sticky header's stacking context; portal them to <body>.
    ['MenuDrawer', 'SearchModal'].forEach((id) => {
      document.querySelectorAll(`body > #${id}`).forEach((old) => old !== document.getElementById(id) && old.remove());
      const el = header.parentElement.querySelector(`#${id}`);
      if (el) { document.querySelectorAll(`body > #${id}`).forEach((o) => o.remove()); document.body.append(el); }
    });

    // Compact after 120px, observed with a sentinel (no scroll listener).
    let sentinel = document.getElementById('ns-header-sentinel');
    if (!sentinel) {
      sentinel = Object.assign(document.createElement('div'), { id: 'ns-header-sentinel' });
      sentinel.style.cssText = 'position:absolute;top:120px;left:0;width:1px;height:1px;pointer-events:none';
      sentinel.setAttribute('aria-hidden', 'true');
      document.body.prepend(sentinel);
    }
    new IntersectionObserver(([e]) => header.classList.toggle('is-compact', !e.isIntersecting)).observe(sentinel);

    // Mega menus: open on click, one at a time.
    const toggles = [...header.querySelectorAll('[data-mega-toggle]')];
    const panelOf = (t) => document.getElementById(t.getAttribute('aria-controls'));
    const closeAll = (except) => toggles.forEach((t) => {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      const p = panelOf(t); if (p) { p.classList.remove('is-open'); p.setAttribute('inert', ''); }
    });
    toggles.forEach((t) => {
      t.addEventListener('click', () => {
        const open = t.getAttribute('aria-expanded') !== 'true';
        closeAll(t);
        t.setAttribute('aria-expanded', open);
        const p = panelOf(t);
        p.classList.toggle('is-open', open);
        p.toggleAttribute('inert', !open);
        if (open) window.NS?.initTabs?.(p);
      });
    });
    // Vertical tabs also follow pointer on desktop.
    header.querySelectorAll('.mega__tab').forEach((tab) => tab.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') tab.click(); }));
    document.addEventListener('click', (e) => { if (!e.target.closest('.hdr__item')) closeAll(); });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = toggles.find((t) => t.getAttribute('aria-expanded') === 'true');
      if (open) { closeAll(); open.focus(); }
    });
    header.addEventListener('focusout', (e) => { if (!header.contains(e.relatedTarget)) closeAll(); });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
